import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    headerContainer: {
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        width: "100%"
    },
    headerButton: {
    },
    actionItem: {
        flexDirection: "row",
        alignItems: "center"
    },
    actionIconContainer: {
    },
    bottomSheet: {
        borderTopLeftRadius: 16,
        borderTopRightRadius: 16
    },
    bottomSheetHeader: {
        alignItems: "center"
    },
    dialogHeader: {
        alignContent: "center",
        alignItems: "center"
    },
    successIconContainer: {
        alignSelf: "center"
    },
    dangerIconContainer: {
        alignSelf: "center"
    },
    textCenter: {
        textAlign: "center"
    }
});
export default stylesheet;
